import styled from 'styled-components';

export const TooltipWrapper = styled.span<{
  isShowing: boolean;
  bottomPos: number;
  position: string;
}>`
  position: absolute;
  background-color: var(--colorBlueGray1200);
  bottom: ${({ bottomPos }) => bottomPos}px;
  border-radius: 4px;
  text-align: center;
  transform: translateY(100%);
  z-index: 1;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 280px;
  color: #fff;
  opacity: ${({ isShowing }) => (isShowing ? 1 : 0)};
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
  letter-spacing: 0.24px;
  padding: 7px 8px 9px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.36;

  &:before {
    content: '';
    width: 12px;
    height: 12px;
    background-color: var(--colorBlueGray1200);
    position: absolute;
    top: ${({ position }) => (position === 'right' ? 22 : -5)}px;
    transform: rotate(45deg);
    left: ${({ position }) => (position === 'right' ? -247 : 0)}px;
    right: 0;
    margin: 0 auto;
  }
`;
